import { render, staticRenderFns } from "./progress-comp.vue?vue&type=template&id=8be1e4e8&scoped=true"
import script from "./progress-comp.vue?vue&type=script&lang=js"
export * from "./progress-comp.vue?vue&type=script&lang=js"
import style0 from "./progress-comp.vue?vue&type=style&index=0&id=8be1e4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be1e4e8",
  null
  
)

export default component.exports